<!-- //
简单的动态表单，用于虚拟滚动内部展示
只需要标题和内容：
支持radio【ok】
支持checkbox【待开发】
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div class="simple-table-wrapper">
    <table class="simple-table" ref="refSimpleTable">
      <thead>
      <tr>
        <th class="simple-table-th"
            v-for="(column, index) in metaData"
            :key="index"
            :style="{
              'width': column.width?  column.width + 'px' : '100px',
              'min-width': column.minWidth ? column.minWidth + 'px' : '',
              'text-align': column.align ? column.align: 'center',
            }">
          {{ column.label }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="!data || data.length <= 0">
        <td class="simple-table-td" :colspan="metaData.length">暂无数据</td>
      </tr>
      <tr v-else v-for="(rowData, rowIndex) in data" :key="rowIndex">
        <td class="simple-table-td"
            v-for="(column, columnIndex) in metaData"
            :key="columnIndex"
            :style="{
              'width': column.width? column.width + 'px' : '100px',
              'min-width': column.minWidth ? column.minWidth + 'px' : '',
              'text-align': column.align ? column.align: 'center',
            }">
          <input type="radio"
                 v-if="column.type === 'radio'"
                 :name="tableId"
                 :value="rowData[rowKey]"
                 :checked="rowData[rowKey] == value"
                 :disabled="!enableStatus"
          />
          <span v-else>
            {{ column.format ? column.format(rowData) : rowData[column.prop] }}
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'ViewSimpleTable',
  data() {
    return {}
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Array], // 返回radio选择的id，或者checkbox选择的ids
      default: () => {
        return null
      }
    },
    tableId: {// 二级table，必须设置父级的row.id,为了区分radio的name
      type: [String, Number],
      default: ''
    },
    rowKey: {// 表中row的唯一键名称
      type: [String],
      default: 'id'
    },
    metaData: {
      type: Array,
      default: () => {
        return []
      }
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    enableStatus: {
      type: Boolean,
      default: false
    },
  },
  computed: {},
  created() {
    // tale 绑定事件
    this.$nextTick(() => {
      if (this.$refs['refSimpleTable']) {
        // debugger
        this.$refs.refSimpleTable.addEventListener('change', (event) => {
          if (event.target && event.target.type === 'radio') {
            let val = event.target.value;
            this.$emit('change', val);
          }
        });
      }
    })
  },
  methods: {
    handleChange(val) {
      console.log("-----------------", val)
      this.$emit('change', this.value);
    }
  }
}
</script>

<style lang="less" scoped>
.simple-table-wrapper {
  width: 100%;
  overflow-x: auto;

  .simple-table {
    width: auto;
    border-collapse: collapse;

    .simple-table-th, .simple-table-td {
      border: 1px solid #ddd;
      padding: 5px;
      text-align: center;
    }
  }
}
</style>
